// This hook is inspired by Akram Khalid
import { useState, useEffect } from "react";

interface IWindowSize {
	width: number;
	height: number;
}

export default function useWindowSize(): IWindowSize {
	function getSize(): IWindowSize {
		return {
			width: typeof window !== "undefined" && window.innerWidth,
			height: typeof window !== "undefined" && window.innerHeight,
		};
	}

	const [windowSize, setWindowSize] = useState(getSize);

	useEffect(() => {
		function handleResize() {
			setWindowSize(getSize());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return windowSize;
}
